import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appLink',
  isDragable: true,
  canOpen: false,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have external links, click on the \"+\" icon to create one.",
  fields: [
    
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'URL of the link.',
    },
  ],
};
